import styled from 'styled-components';
import { Layout } from 'antd';
import { colors } from 'theme';

export const StyledLayout = styled(Layout)`
    height: 100vh;
    background: ${colors.lightGrey};
`;

export const StyledContent = styled(Layout.Content)`
    padding: 24px;
    overflow: auto;
    background-color: var(--gray-2);
`;
